import { IconButton } from "@material-ui/core";
import { CloseRounded } from "@material-ui/icons";
import React from "react";
import * as S from "./styles";

export default function ThumbPreview({ removeVideo, thumbnail, ...props }) {
  return (
    <S.MinPreview {...props}>
      <S.GetThumbnailVideo id="video" src={thumbnail} type="video/mp4" />
      <IconButton onClick={removeVideo} className="remove-video">
        <CloseRounded style={{ color: "#FFF", fontSize: 12 }} />
      </IconButton>
    </S.MinPreview>
  );
}
